<template>
  <modal-form :class="$style.dialog" @cancel="$formCancelHandler" @submit="$formSubmitHandler">
    <span slot="header">Change Email Address</span>
    <div slot="body" class="vModalDefaultBody">
      <rb-input for-id="email" :error="$showError('email')">
        <span slot="label">New Email Address</span>
        <input
          id="email"
          v-model="data.emailAddress"
          v-validate="{required: true, email: true, max: 255}"
          type="email"
          name="email"
          class="rbInput"
          autofocus
          data-vv-as="Email Address"
        >
      </rb-input>

      <rb-input for-id="confirmEmail" :error="$showError('confirmEmail')">
        <span slot="label">Confirm New Email Address</span>
        <input
          id="confirmEmail"
          v-model="data.confirmEmailAddress"
          v-validate="{ required: true, value: data.emailAddress }"
          type="email"
          name="confirmEmail"
          class="rbInput"
          data-vv-as="Confirm Email Address"
        >
      </rb-input>
    </div>
  </modal-form>
</template>

<script>
  import ModalForm from 'vRoot/_core/RbModalForm.vue'
  import DialogMixin from 'vRoot/_mixins/DialogMixin.vue'
  import RbFormMixin from 'vRoot/_mixins/RbFormMixin.vue'
  import RbInput from 'vRoot/_core/RbInput.vue'

  export default {
    name: 'RbvUserProfileEditPersonalInfoDialog',
    components: { RbInput, ModalForm },
    mixins: [ RbFormMixin, DialogMixin ],
    data() {
      return {
        data: {
          emailAddress: '',
          confirmEmailAddress: ''
        }
      }
    },
    methods: {
      onSubmit () { return { form: { emailAddress: this.data.emailAddress } } }
    }
  }
</script>

<style lang="stylus" module="">

  .dialog {
    min-width 400px
  }

</style>

